export const ERROR_CONSTANTS = {
    ITEM_ACTION_ERROR: (item: string, action: string): string => `Error ${action} ${item}.`
};
